<template>
  <div>
    <Menu />
    <div
      class="container main"
      v-if="id_funcao == 1 || id_funcao == 7 || id_funcao == 2"
    >
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Relatório atendimentos"
            description="Atendimentos, procedimentos, vacinas ou visitas realizados nos últimos 90 dias"
            url="/dashboard"
          />
        </div>
        <div class="col-md-12">
          <div class="filter-select">
            <vue-select
              :options="estabelecimentos"
              label="no_unidade_saude"
              placeholder="UBS"
              @input="onChangeEstabelecimento"
              v-model="selectedEstabelecimento"
            >
              <template slot="option" slot-scope="option">
                {{ option.no_unidade_saude }} - {{ option.nu_cnes }}
              </template>
              <div slot="no-options">Não há opções correspondentes</div>
            </vue-select>
            <vue-select
              :options="equipes"
              label="no_equipe"
              placeholder="Equipes"
              @input="onChangeEquipe"
              v-model="selectedEquipe"
            >
              <template slot="option" slot-scope="option">
                {{ option.no_equipe }}
                {{ option.nu_ine != 'sem-equipe' ? '- ' + option.nu_ine : '' }}
              </template>
              <div slot="no-options">Não há opções correspondentes</div>
            </vue-select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <table class="table table-responsive table-striped" id="table">
            <thead class="thead-light">
              <tr>
                <th>CNS</th>
                <th>Nome</th>
                <th>Função</th>
                <th>INE</th>
                <th>Atendimentos</th>
                <th>Ação</th>
              </tr>
            </thead>
            <loader-table-skeleton
              :cols="6"
              :rows="10"
              :active="loading"
            ></loader-table-skeleton>
            <tbody v-if="loading == false">
              <tr
                v-for="(item, index) in displayedProfissionais"
                v-bind:key="index"
              >
                <td>{{ item.nu_cns }}</td>
                <td>{{ item.no_profissional }}</td>
                <td>{{ item.no_cbo }}</td>
                <td>{{ item.ine }}</td>
                <td>{{ item.atendimentos }}</td>
                <td>
                  <router-link
                    :to="{
                      name: 'AtendimentosNoMesDetalhar',
                      params: { nu_cpf: item.nu_cpf, co_cbo: item.co_cbo },
                    }"
                    ><button class="btn-table" style="margin-top: 0px">
                      Detalhar
                    </button></router-link
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-md-12">
          <pagination
            :page="page"
            :pages="pages"
            v-on:update:page="page = $event"
          >
          </pagination>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '../../components/Menu'
import Footer from '../../components/Footer'
import SectionTitle from './SectionTitle'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import LoaderTableSkeleton from '../../components/LoaderTableSkeleton.vue'
import Pagination from '@/components/utils/Pagination'
import utils from '@/mixins/utils.js'
import ModalInfo from './ModalInfo'

export default {
  name: 'AtendimentosNoMesPorEquipe',
  components: {
    Menu,
    Footer,
    PulseLoader,
    SectionTitle,
    LoaderTableSkeleton,
    Pagination,
    ModalInfo,
  },
  mixins: [utils],
  computed: {
    estabelecimentos() {
      return this.$store.getters['getEquipes']
    },
    displayedProfissionais() {
      this.setPages(this.profissionais)
      return this.paginate(this.profissionais)
    },
    ultimaAtualizacao() {
      return this.$store.getters['getUltimaAtualizacao']
    },
  },
  data() {
    return {
      id_funcao: '',
      cod_ibge: '',
      user_id: '',
      equipes: [],
      equipe: '',
      atendimentos: [],
      profissionais: [],
      page: 1,
      perPage: 10,
      pages: [],
      periodo: '',
      loading: false,
      size: '40px',
      color: '#0D98BB',
      selectedEquipe: '',
      selectedEstabelecimento: '',
      profissionaisOriginais: [],
    }
  },
  methods: {
    setPages(profissionais) {
      let numberOfPages = Math.ceil(profissionais.length / this.perPage)
      this.pages = []
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index)
      }
    },

    paginate(profissionais) {
      let page = this.page
      let perPage = this.perPage
      let from = page * perPage - perPage
      let to = page * perPage
      return profissionais.slice(from, to)
    },

    async onChangeEstabelecimento(item) {
      this.selectedEquipe = null
      this.profissionais = []
      const equipes = this.$store.getters['getEquipes']
      let equipesDoEstabelecimento = equipes.filter((element) => {
        return element.nu_cnes == item.nu_cnes
      })
      this.equipes = equipesDoEstabelecimento
      this.loading = true
      try {
        let response = await this.$api.get(
          '/app/atendimentos-no-mes/equipe/' +
            this.cod_ibge +
            '/' +
            item.nu_cnes
        )
        if (response) {
          this.profissionaisOriginais = response.data
          this.profissionais = response.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    async onChangeEquipe(equipe) {
      if (equipe == null) {
        this.profissionais = this.profissionaisOriginais
        return
      }
      this.profissionais = this.profissionaisOriginais.filter((item) => {
        return item.ine != null && item.ine == equipe.nu_ine
      })
    },

    validateToken() {
      this.id_funcao = this.$store.state.id_funcao
      this.user_id = this.$store.state.id
      this.cod_ibge = this.$store.state.cod_ibge
    },
  },
  created() {
    this.validateToken()
  },
}
</script>

<style></style>
